import { createSelector } from 'reselect';
import { RootState } from '../state';

export const selectDeliveryZones = (state: RootState) => state.deliveryZone.byId;

export const selectDeliveryZoneById = createSelector([selectDeliveryZones, (_, id: number) => id], (deliveryZonesById, id) => deliveryZonesById[id]);
